// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__gaiN7","info":"UpdateTermsInfo_info__2q1qC"};